<se-fe-modal-button [seFeDataButton]="{icon: true}" (seFeButtonAction)="openModal($event)">
  <se-fe-icon
    seFeModalIcon
    seFeDataName="pencil_fill"
    seFeDataSize="500"
    seFeDataColor="default"
    seFeDataAriaLabel="Edit media"></se-fe-icon>
</se-fe-modal-button>

<se-fe-modal seFeDataSize="large" #mediaModal (seFeClose)="resetForm()">
  <div seFeModalHeader>
    <div class="media-modal-header">
      <h2 class="media-modal-title">Edit product images</h2>
      <se-fe-icon-button (click)="closeModal()">
        <se-fe-icon
          seFeDataName="remove"
          seFeDataSize="500"
          seFeDataColor="default"
          seFeDataAriaLabel="Close"></se-fe-icon>
      </se-fe-icon-button>
    </div>
  </div>

  <se-fe-modal-content>
    <!-- NOTE: Keep these actions custom instead of using `seFeDataActions`.
        The built-in modal action buttons currently throw NG0100 in `SeFeModalButtonComponent`
        during image uploader state changes (upload/delete/save), and `seFeModalFooter` is deprecated. -->
    <form [formGroup]="form" novalidate>
      <se-fe-grid seFeGridOpts="snug">
        <se-fe-grid-cell seFeGridOpts>
          @if (imagesReady) {
            <se-fe-form-field [seFeDataConfig]="productImageLabel"></se-fe-form-field>
            @if (allowMultiple()) {
              <multi-image-upload-field
                [imagesFormArray]="imagesFormArray"
                [parentForm]="form"
                [defaultImgUrl]="currentImageUrl"
                [altValidators]="mediaModalAltValidators"
                [clearImagesOnManualUploaderClear]="true"
                (uploadFailed)="onImageFailure()"
                (uploadSucceeded)="onMultiImageUploadSucceeded()"
                (imagesChanged)="onMultiImagesChanged()"></multi-image-upload-field>
            } @else {
              <se-fe-image-uploader
                #imageUploader
                seFeAcceptFormat="image/png, image/jpeg"
                [seFeDataDefaultImgUrl]="currentImageUrl"
                [seFeDataMultiple]="false"
                [seFeDataMaxFiles]="1"
                (uploadSuccess)="onImageSuccess($event)"
                (uploadFailed)="onImageFailure()"
                (uploadCleared)="uploadCleared()"
                [seFeDataUploadedItemsHidden]="true"></se-fe-image-uploader>
            }

            @if (!allowMultiple() && imagesFormArray.length) {
              <div class="image-list">
                @for (imgGroup of imagesFormArray.controls; track imgGroup) {
                  <div class="image-row">
                    <div class="media-modal-image-row">
                      <img
                        class="media-modal-thumb"
                        [src]="getSrcControlValue(imgGroup)"
                        [alt]="getAltControlValue(imgGroup)"
                        width="76"
                        height="76" />
                      <se-fe-form-field class="modal-form-field" [seFeDataConfig]="getImageDescriptionConfig($index)">
                        <se-fe-form-field-text
                          [formControl]="getAltControl(imgGroup)"
                          seFeDataAutoComplete="off"></se-fe-form-field-text>
                      </se-fe-form-field>
                      <input type="hidden" [formControl]="getSrcControl(imgGroup)" />
                      <div class="media-modal-image-actions">
                        <se-fe-icon-button
                          seFeDataEmphasis="medium"
                          [seFeTooltipTrigger]="removeTooltip"
                          (click)="removeImage($index)"
                          [seFeDataButtonAttrs]="{'aria-label': 'Remove image ' + ($index + 1)}">
                          <se-fe-icon
                            seFeDataName="close"
                            seFeDataSize="500"
                            [seFeDataAriaLabel]="'Remove image ' + ($index + 1)"
                            [seFeDataMargin]="false"></se-fe-icon>
                        </se-fe-icon-button>
                        <se-fe-tooltip #removeTooltip>Remove image</se-fe-tooltip>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          }

          @if (error()) {
            <se-fe-alert seFeDataType="error" class="media-help">
              {{ error() }}
            </se-fe-alert>
          }

          <se-fe-banner
            seFeDataTitle="What should go in the image description?"
            seFeDataIconName="info_circle"
            [seFeDataDismissible]="false">
            <div seFeBannerSubtitle>
              The image description is used as alt text for accessibility. Write a short summary of what the image shows
              and the meaning it conveys, including key details like product name, visible text, and other context. Do
              not use phrases like “image of” or “photo of.”
            </div>
          </se-fe-banner>
        </se-fe-grid-cell>
      </se-fe-grid>
    </form>
    <div class="media-modal-footer">
      <se-fe-button seFeDataEmphasis="low" [seFeDataIsDisabled]="isSaving" (click)="closeModal()">Cancel</se-fe-button>
      <se-fe-button
        seFeDataEmphasis="high"
        [seFeDataIsDisabled]="saveDisabled()"
        [seFeDataIsLoading]="isSaving"
        (click)="handleAction()">
        Save
      </se-fe-button>
    </div>
  </se-fe-modal-content>
</se-fe-modal>
